// @flow

import type { ExpandedSpecificationDTO, SpecificationPatchType, FieldDTO } from './Types/Field'
import type { ProductContent, ProductPatchType } from './Types/ProductContent'

const mergeField = (field: FieldDTO<ExpandedSpecificationDTO>, patch: FieldDTO<ExpandedSpecificationDTO>) => ({
  ...field,
  ...patch,
  domain: {
    ...field.domain,
    ...patch.domain
  }
})

export const patchSpecification = (specification: ExpandedSpecificationDTO, patch?: SpecificationPatchType) => {
  let newSpecification = { ...specification }
  if (patch && patch[specification.name]) {
    newSpecification.fields = newSpecification.fields.map((field) => {
      // $FlowIssue
      if (patch[specification.name][field.name]) {
        // $FlowIssue
        return mergeField(field, patch[specification.name][field.name])
      }
      return field
    })
  }
  if (patch && specification.types) {
    newSpecification.types = newSpecification.types.map((spec) => patchSpecification(spec, patch))
  }
  return newSpecification
}

export const patchContent = (content: ProductContent, patch?: ProductPatchType) => {
  let newContent: ProductContent = { ...content }
  if (patch && patch.fieldOrder) {
    newContent.fieldOrder = patch.fieldOrder
  }
  if (patch && patch.fieldNames) {
    newContent.fieldNames = patch.fieldNames
  }
  if (patch && patch.types) {
    newContent.types = Object.keys(newContent.types).reduce((acc, key) => {
      acc[key] = patchContent(newContent.types[key], patch.types[key])
      return acc
    }, {})
  }
  return newContent
}
